// ****************
// WARNING:  There is a matching version of this code in R.Web.Apps and R.Marketing.Website
// as all 3 sources need to track the same information
// Please keep all 3 in sync with any changes!!!!!!
// ****************
import { addDays, isFuture, isPast } from "date-fns";

import { getTokenFromStorage, storeTokenInStorage } from ".";

const ATTRIBUTION_KEY = "relode:tracking:attribution:key";
const SPONSOR_KEY = "relode:tracking:sponsor:key";
const EXPIRE_DAYS = 30;

export const attributionService = {};

export const getAttributionInfo = (): Attribution => {
    const attribution: Attribution = {};

    const utmTracking = getTokenFromStorage<Attribution>(ATTRIBUTION_KEY);
    if (!!utmTracking) {
        if (isFuture(new Date(utmTracking.expires))) {
            attribution.utm_campaign = utmTracking.utm_campaign;
            attribution.utm_content = utmTracking.utm_content;
            attribution.utm_medium = utmTracking.utm_medium;
            attribution.utm_term = utmTracking.utm_term;
            attribution.utm_source = utmTracking.utm_source;
        }
    }

    const sponsorTracking = getTokenFromStorage<Sponsor>(SPONSOR_KEY);
    if (!!sponsorTracking) {
        if (isFuture(new Date(sponsorTracking.expires))) {
            attribution.sponsor = sponsorTracking.sponsor;
        }
    }

    return attribution;
};

export function setAttributionInfo(attribution: Attribution) {
    const future = addDays(new Date(), EXPIRE_DAYS);
    const futureJson = future.toJSON();

    //check each prop.
    if (
        attribution.utm_campaign ||
        attribution.utm_content ||
        attribution.utm_medium ||
        attribution.utm_term ||
        attribution.utm_source
    ) {
        const utmTracking: Attribution = {
            utm_campaign: attribution.utm_campaign,
            utm_content: attribution.utm_content,
            utm_medium: attribution.utm_medium,
            utm_term: attribution.utm_term,
            utm_source: attribution.utm_source,
            expires: futureJson,
        };
        // Per Marketing, last in wins for UTM up to EXPIRE_DAYS days
        storeTokenInStorage(ATTRIBUTION_KEY, utmTracking);
        console.info(
            `relode | attribution | source: ${attribution.utm_source} | medium: ${attribution.utm_medium} | ` +
                `campaign: ${attribution.utm_campaign} | content: ${attribution.utm_content} | ` +
                `term: ${attribution.utm_term}`
        );
    }

    if (attribution.sponsor) {
        const existingSponsor = getTokenFromStorage<Sponsor>(SPONSOR_KEY);
        // first in wins for sponsor up to EXPIRE_DAYS days
        if (!existingSponsor || isPast(new Date(existingSponsor.expires))) {
            const sponsorTracking: Sponsor = {
                sponsor: attribution.sponsor,
                expires: futureJson,
            };

            storeTokenInStorage(SPONSOR_KEY, sponsorTracking);
            console.info(`relode | sponsor | ${sponsorTracking.sponsor}`);
        }
    }
}

export function addAttribution(anyObject) {
    const attributions = getAttributionInfo();
    anyObject = { ...anyObject, ...attributions };
    return anyObject;
}

export interface Attribution {
    utm_campaign?: string;
    utm_content?: string;
    utm_medium?: string;
    utm_term?: string;
    utm_source?: string;
    sponsor?: string;
    // WARNING: this should be a Date but because it's out there already leaving it a string
    expires?: string;
}

export interface Sponsor {
    sponsor?: string;
    // WARNING: this should be a Date but because it's out there already leaving it a string
    expires?: string;
}
